import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppSessionService } from "../app-session/app-session.service";

@Injectable({
  providedIn: "root",
})
export class FuelPointService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  createFuelPoint(fuelpoint: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(fuelpoint);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/fuelPoints"}`;
    return this.http.post(url, data, { headers });
  }

  updateFuelPoint(fuelpoint: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(fuelpoint);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/fuelPoints"}/${
      fuelpoint?.code
    }`;
    return this.http.put(url, data, { headers });
  }
}
